import React, {useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import moment from "moment";

import Loading from "@/components/Loading";
import Page from "@/components/Page";
import Breadcrumbs from "@/components/Breadcrumbs";
import EmptyData from "@/components/EmptyData";
import MainActions from "@/components/MainActions";
import VLFCard from "@/components/Card";
import ViewField from "@/components/Input/ViewField";
import VLFModal from "@/components/Modal";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import {PlayerValuationAPI} from "@/api/player_valuation";

import {
	ERROR_OPERATION,
	SUCCESSFUL_OPERATION,
	baseExternTrainingParameters,
	dateFormat,
	proExternTrainingParameters,
} from "@/utils/constants";
import {getAlertSeverity} from "@/utils/functions";

import "./index.scss";
import {useTranslation} from "react-i18next";

function Tryout(props) {
	const {handleNotification} = props;

	const {id} = useParams();
	const navigate = useNavigate();
	const {t} = useTranslation();

	const [loading, setLoading] = useState(false);
	const [openHandleConfirm, setOpenHandleConfirm] = useState(false);
	const [valuationData, setValuationData] = useState({});

	const getValuation = async () => {
		setLoading(true);
		try {
			const response = await PlayerValuationAPI.getById(id);
			setValuationData(response);
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
		} finally {
			setLoading(false);
		}
	};
	useEffect(() => {
		getValuation();
	}, []);

	const deleteValuation = async () => {
		setLoading(true);
		try {
			await PlayerValuationAPI.delete(valuationData?.id);
			handleNotification(SUCCESSFUL_OPERATION, "success");
			navigate("/scouting/tryouts");
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
			setLoading(false);
		} finally {
			setOpenHandleConfirm(false);
		}
	};

	const currentPlayerData = valuationData?.player;

	let parameters = [];
	if (valuationData?.category) {
		if (!valuationData.category?.basicActivities) {
			parameters = proExternTrainingParameters(t);
		} else {
			parameters = baseExternTrainingParameters(t);
		}
	}

	const reportDetailsConfiguration = parameters.map((p) => {
		return {
			value: (
				<div className="area-rating-container">
					{valuationData[p.fieldKeyRating] && (
						<div className="stat-circle-container">
							<div className="stat-container">
								<div className="value">
									{+parseFloat(valuationData[p.fieldKeyRating]).toFixed(2)}
								</div>
							</div>
						</div>
					)}
					{valuationData?.[p.fieldKey] && (
						<div className="rating-notes">{valuationData?.[p.fieldKey]}</div>
					)}
					{!valuationData?.[p.fieldKeyRating] &&
						!valuationData?.[p.fieldKey] && <EmptyData />}
				</div>
			),
			label: p.label,
			size: "col-12 col-sm-6",
		};
	});
	reportDetailsConfiguration.push({
		value: (
			<div className="area-rating-container only-text">
				{valuationData?.finalOverallValuation ? (
					<div className="rating-notes">
						{valuationData?.finalOverallValuation}
					</div>
				) : (
					<EmptyData />
				)}
			</div>
		),
		label: "Valutazione complessiva finale",
		size: "col-12 ",
	});
	reportDetailsConfiguration.push({
		value: (
			<div className="area-rating-container only-text">
				{valuationData?.valuationText ? (
					<div className="rating-notes big">{valuationData?.valuationText}</div>
				) : (
					<EmptyData />
				)}
			</div>
		),
		label: "Relazione generale",
		size: "col-12",
	});

	const mainActions = [
		{
			icon: <ArrowBackIcon />,
			title: "Indietro",
			onClick: () => navigate(-1),
			color: "info",
		},
		{
			icon: <EditIcon />,
			title: "Modifica",
			onClick: () =>
				navigate("/scouting/tryouts/" + valuationData?.id + "/edit"),
		},
		{
			icon: <DeleteIcon />,
			title: "Elimina",
			onClick: () => setOpenHandleConfirm(true),
			color: "error",
		},
	];

	const breadcrumbsElements = [
		{
			label: "Provini",
			path: "/scouting/tryouts",
		},
		{label: "/"},
	];

	return (
		<Page className="page-container">
			<Loading visible={loading} />
			<Breadcrumbs
				elements={breadcrumbsElements}
				current={
					valuationData
						? moment(valuationData?.valuationDate).format(dateFormat) +
							" " +
							(currentPlayerData?.firstName || "") +
							" " +
							(currentPlayerData?.lastName || "")
						: ""
				}
				actions={<MainActions actions={mainActions} />}
			/>
			<div className="sheet-container">
				<div className="row no-margin col-container">
					<div className="col-sm-12 col-lg-12 padding-small">
						<VLFCard
							title="Provino"
							content={
								<div className="row">
									{/* <div className="col-sm-12 col-lg-10">
										<ViewField configuration={reportConfiguration} />
									</div> */}
									{/* <div className="col-sm-12 col-lg-10"> */}
									<div className="tryout-details-container">
										<div className="detail-container">
											<div className="label">Giocatore</div>
											<div className="value">
												{currentPlayerData
													? currentPlayerData?.firstName +
														" " +
														currentPlayerData?.lastName
													: "---"}
											</div>
										</div>
										<div className="detail-container">
											<div className="label">Data di nascita</div>
											<div className="value">
												{currentPlayerData?.dateOfBirth
													? moment(currentPlayerData?.dateOfBirth).format(
															dateFormat,
														)
													: "---"}
											</div>
										</div>
										<div className="detail-container">
											<div className="label">Squadra</div>
											<div className="value">{valuationData?.club?.name}</div>
										</div>
										<div className="detail-container">
											<div className="label">Altezza</div>
											<div className="value">
												{valuationData?.height
													? valuationData?.height + " cm"
													: ""}
											</div>
										</div>
										<div className="detail-container">
											<div className="label">Peso</div>
											<div className="value">
												{valuationData?.weight
													? valuationData?.weight + " kg"
													: ""}
											</div>
										</div>
									</div>
									<div className="tryout-details-container">
										<div className="detail-container">
											<div className="label">Data</div>
											<div className="value">
												{valuationData?.valuationDate
													? moment(valuationData?.valuationDate).format(
															dateFormat,
														)
													: null}
											</div>
										</div>
										<div className="detail-container">
											<div className="label">Allenatore</div>
											<div className="value">
												{valuationData?.valuationAuthor}
											</div>
										</div>
										<div className="detail-container">
											<div className="label">Periodo di prova</div>
											<div className="value"> {valuationData?.trialPeriod}</div>
										</div>
										<div className="detail-container">
											<div className="label">Categoria</div>
											<div className="value">
												{valuationData?.category?.name}
											</div>
										</div>
										<div className="detail-container">
											<div className="label">Ruolo</div>
											<div className="value">
												{currentPlayerData?.goalkeeper
													? "Portiere"
													: currentPlayerData?.primaryRole}
											</div>
										</div>
									</div>
									{/* </div> */}
									<div className="col-sm-12 col-lg-2">
										<div
											className="d-flex flex-column align-items-center gap-2 h-100"
											style={{borderLeft: "1px solid #ebf1fd"}}
										>
											<div className="view-field-container avg h-100 justify-content-center">
												<div className="field-label-container justify-content-center">
													<div className="field-label">Voto finale</div>
												</div>
												<div className="stat-circle-container">
													<div className="stat-container">
														<div className="value">
															{
																+parseFloat(
																	valuationData?.finalAverage || 0,
																).toFixed(2)
															}
														</div>
													</div>
												</div>
											</div>
											<div className="view-field-container avg h-100 justify-content-center">
												<div className="field-label-container justify-content-center">
													<div className="field-label">Esito</div>
												</div>
												<div className="d-flex justify-content-center">
													<div
														style={{maxWidth: "150px"}}
														className={
															"severity " +
															(getAlertSeverity(
																valuationData?.finalOverallRating,
																true,
															)?.severity || "")
														}
													>
														{
															getAlertSeverity(
																valuationData?.finalOverallRating,
																true,
															)?.message
														}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							}
							openable={false}
						/>
					</div>
				</div>

				<div className="row no-margin mt-2">
					<div className="col-sm-12 padding-small">
						<VLFCard
							title="Dettagli"
							content={
								<div className="row">
									<div className="col-sm-12">
										<ViewField configuration={reportDetailsConfiguration} />
									</div>
								</div>
							}
							openable={false}
						/>
					</div>
				</div>
			</div>
			<VLFModal
				open={openHandleConfirm}
				title="Eliminazione"
				content={
					<div className="mt-2">
						Sei sicuro di voler eliminare questo elemento?
					</div>
				}
				confirm={() => deleteValuation()}
				close={() => setOpenHandleConfirm(false)}
				confirmLabel="Conferma"
			/>
		</Page>
	);
}

export default Tryout;
